<template>
  <div>
    <div class="row justify--space-between align--center ma-0 mb-4">
      <h1 :style="{ color: $themes.primary, textTransform: 'uppercase' }">{{ title }}</h1>
      <va-button @click="() => $router.push({ name: 'new-provider' })" class="ma-0">{{ $t("providers.new") }}</va-button>
    </div>

    <data-table-providers class="mb-4" />
  </div>
</template>

<script>
import DataTableProviders from '../components/DataTableProviders.vue'

export default {
  data: () => ({
    title: 'Prestadores de Serviço',
  }),
  components: {
    DataTableProviders,
  },
}
</script>
